var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000305176 4.04464V14.5179C0.000305176 15.4821 0.376862 16.3393 0.979352 17.0089C1.58184 17.6518 2.36006 18 3.26379 18H8.18413V15.8304H3.26379C2.58599 15.8304 2.05881 15.2411 2.05881 14.5179V4.04464C2.05881 3.32143 2.58599 2.75893 3.26379 2.75893H8.18413V0.5625H3.26379C2.36006 0.5625 1.58184 0.9375 0.979352 1.58036C0.376862 2.25 0.000305176 3.08036 0.000305176 4.04464ZM5.39761 7.20536V11.3839C5.39761 11.8661 5.79927 12.2679 6.25114 12.2679H10.7949V15.5625C10.7949 15.8571 10.9455 16.0982 11.1966 16.2321C11.297 16.2589 11.3974 16.2589 11.4476 16.2589C11.6233 16.2589 11.774 16.2054 11.8995 16.0714L17.7989 9.77679C18.075 9.53571 18.0499 9.05357 17.7989 8.78571L11.8995 2.51786C11.548 2.11607 10.7949 2.35714 10.7949 3V6.32143H6.25114C5.79927 6.32143 5.39761 6.72321 5.39761 7.20536Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.fa6fa2476c2cc0ec21be01ec9a428d75.svg";
export { ForwardRef as ReactComponent };